import { render, staticRenderFns } from "./ota-detail.vue?vue&type=template&id=016218d0&scoped=true&"
import script from "./ota-detail.vue?vue&type=script&lang=tsx&"
export * from "./ota-detail.vue?vue&type=script&lang=tsx&"
import style0 from "./ota-detail.vue?vue&type=style&index=0&id=016218d0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "016218d0",
  null
  
)

export default component.exports